import script from "./EmailSettingAccountNotSynced.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSettingAccountNotSynced.vue?vue&type=script&setup=true&lang=ts"

import "./EmailSettingAccountNotSynced.vue?vue&type=style&index=0&id=add53ba8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add53ba8"]])

export default __exports__